import { render, staticRenderFns } from "./AddEditGroupMail.vue?vue&type=template&id=5c5b3640"
import script from "./AddEditGroupMail.vue?vue&type=script&lang=js"
export * from "./AddEditGroupMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports